<template>
  <div class="status-bar">
    <timeline-step status="declined" title="Application Declined">
      <template v-slot:caption>
        <p>
          Unfortunately, we were unable to approve your application. Thank you for giving us the
          opportunity to meet your education finance needs. For full details on your application
          decision, please refer to your Adverse Action Notice which may be accessed in the
          <a class="inline-link" @click="goToMyDocuments">My Documents</a> section of your applicant
          portal soon.
        </p>
        <p>
          If you'd like to speak with our College Access Counselor to understand more about the
          decision, you can schedule a complimentary consultation
          <a
            class="inline-link"
            :href="collegeCounselorSchedulerUrl"
            target="_blank"
						aria-description="Link to schedule a complimentary consulation with the College Access Counselor"
            >here</a
          >.
        </p></template
      >
    </timeline-step>
  </div>
</template>
<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import { useStore } from "vuex";
import { computed } from "vue";

const emit = defineEmits(["downloadAdverseActionNotice"]);
const router = useRouter();
const route = useRoute();
const store = useStore();

interface Props {
  noticeReady?: boolean | undefined;
}

const props = withDefaults(defineProps<Props>(), {});

const collegeCounselorSchedulerUrl = computed<string>(() => store.state.configuration?.collegeCounselorSchedulerUrl);

function goToMyDocuments(query?: any) {
  router.push({
    name: "ApplicationDocuments",
    query: {
      ...route.query,
      ...query,
    },
  });
}
</script>
